import { render, staticRenderFns } from "./BlockEditInvalid.vue?vue&type=template&id=07185019"
import script from "./BlockEditInvalid.vue?vue&type=script&lang=js"
export * from "./BlockEditInvalid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports